import {React, useState} from 'react';
import { Form, Layout, Input, Button, Upload, Select, Modal, Table} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import Title from 'antd/lib/typography/Title';
import Sidebar from '../../Side_Bar/Admin_Side_Bar.js';
import {Link, useLocation, useNavigate} from 'react-router-dom';

const { Option } = Select;
const { Sider} = Layout;

const CustomerForm = () => {
  const location = useLocation();
  const [form] = Form.useForm();
  const mainUrl               = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";

  const [isChangeOk, setIsChangeOk] = useState(false);
  const [isChangeNotOk, setIsChangeNotOk] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    // Add logic to send the form data to the server or perform other actions
    console.log('Form submitted:', values);

    const parametersToInclude = [
      'name',
      'ssmNo',
      'address',
      'businessDescription',
      'industry',
      'adminEmail',
      'financeEmail',
      'notificationEmail',
      'adminName',
      'adminContactNumber',
      'websiteURL',
      'facebookURL',
      'instagramURL',
      'username',
      'password'
    ];
    
    const requestBody = {};
    
    parametersToInclude.forEach(param => {
      requestBody[param] = values[param];
    });
    
    const insertCustomerUrl = `${mainUrl}/insertCustomer`;
    
    fetch(insertCustomerUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Response from server:', data);
        setIsChangeOk(true);
      })
      .catch(error => {
        console.error('Error:', error);
        setIsChangeNotOk(true);
      });
    

    // Reset the form after submission
    form.resetFields();
  };

  const handleModalOk = () => {
    // Handle the OK button in the modal
    // For example, navigate to another page or perform additional actions
    setIsChangeOk(false);
    navigate('/view_edit_customer');
  };

  const handleModalNotOk = () => {
    // Handle the OK button in the modal
    // For example, navigate to another page or perform additional actions
    setIsChangeNotOk(false);
    navigate('/view_edit_customer');
  };


  const boxHeight = '50px';
  return (
    <Layout style={{ minHeight: '98vh' }}>
        <Sidebar location={location} />
      <Layout style={{ background: 'white'}}>
        <Title level={2} style={{marginTop: "0px", margin: "20px", fontWeight: "bold", textAlign: "left"}}>ADD COMPANY PROFILE</Title>
          <div style={{ maxWidth: "100%", margin: '20px', textAlign: 'center', fontFamily: 'Helvetica, Arial, sans-serif' }}>
            <Title level={4} style={{marginTop: "10px"}}>Basic Information</Title>
            <Form
              form={form}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 16 }}
              onFinish={onFinish}
              initialValues={{ remember: true }}
            >
              {/* Basic Information */}
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
              <Form.Item
                name="name"
                rules={[{ required: true, message: 'Please enter the name' }]}
                style={{ fontSize: '16px', flex: '1', marginRight: "35%"}}
              >
                <Input 
                placeholder="Company Name"
                style={{ height: boxHeight, width: '300%' }} />
              </Form.Item>

              <Form.Item
                name="industry"
                rules={[{ required: true, message: 'Please select the industry' }]}
                style={{ fontSize: '16px', flex: '1' }}
              >
                <Select 
                placeholder="Company Industry"
                style={{ width: '150%', height: boxHeight }}
                >
                  <Option value="Retail">Retail</Option>
                  <Option value="Construction">Construction</Option>
                  <Option value="Transport">Transport</Option>
                  <Option value="Agriculture">Agriculture</Option>
                  <Option value="Manufacturing">Manufacturing</Option>
                  <Option value="F&B">F&B</Option>
                  <Option value="Pharmaceutical">Pharmaceutical</Option>
                  <Option value="Other">Other</Option>
                </Select>
              </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="ssmNo"
                  rules={[{ required: true, message: 'Please enter the SSM No' }]}
                  style={{ fontSize: '16px', flex: '1'}}
                >
                  <Input 
                  placeholder = "Company SSM No"
                  style={{ height: boxHeight, width: '150%' }} />
                </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
              <Form.Item
                    name="address"
                    rules={[{ required: true, message: 'Please enter the address' }]}
                    style={{ fontSize: '16px', flex: '1'}}
                  >
                    <Input 
                    placeholder = "Company Address"
                    style={{ height: boxHeight, width: '150%' }} />
              </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
              <Form.Item
                    name="businessDescription"
                    rules={[{ required: true, message: 'Please enter the business description' }]}
                    style={{ fontSize: '16px', flex: '1' }}
                  >
                    <Input 
                    placeholder="Company Description"
                    style={{ height: boxHeight , width: '150%' }}/>
              </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
              <Form.Item
                name="websiteURL"
                rules={[{ type: 'url', message: 'Please enter a valid URL' }]}
                style={{ fontSize: '16px', flex: '1', marginRight: '2%' }}
              >
                <Input 
                placeholder="Website URL"
                style={{ height: boxHeight, width: "150%" }}/>
              </Form.Item>

              <Form.Item
                name="facebookURL"
                rules={[{ type: 'url', message: 'Please enter a valid URL' }]}
                style={{ fontSize: '16px', flex: '1', marginRight: '2%' }}
              >
                <Input 
                placeholder="Facebook URL"
                style={{ height: boxHeight, width: "150%" }}/>
              </Form.Item>

              <Form.Item
                name="instagramURL"
                rules={[{ type: 'url', message: 'Please enter a valid URL' }]}
                style={{ fontSize: '16px', flex: '1' }}
              >
                <Input 
                placeholder="Instagram URL"
                style={{ height: boxHeight, width: "150%" }}/>
              </Form.Item>
            </div>
              {/* Contact and Logo */}
              <Title level={4} style={{marginTop: "10px"}}>Admin Details</Title>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="adminName"
                  rules={[{ required: true, message: 'Please enter the PIC name' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                >
                  <Input 
                  placeholder="Person In Charge (PIC) Name"
                  style={{ height: boxHeight, width: "150%"  }}/>
                </Form.Item>
            </div>
            
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="adminContactNumber"
                  rules={[{ required: true, message: 'Please enter the PIC contact number' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                >
                  <Input 
                  placeholder="Person In Charge (PIC) Contact number"
                  style={{ height: boxHeight, width: '150%'  }}/>
                </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="adminEmail"
                  rules={[{ required: true, message: 'Please enter the PIC email' }]}
                  style={{ fontSize: '16px' , flex: '1'}}
                >
                  <Input 
                  placeholder="Person In Charge (PIC) Email"
                  type="email" 
                  style={{ height: boxHeight, width: "150%" }}/>
                </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="financeEmail"
                  rules={[{ required: true, message: 'Please enter the finance email' }]}
                  style={{ fontSize: '16px' , flex: '1'}}
                >
                  
                  <Input 
                  placeholder="Finance Email"
                  type="email" 
                  style={{ height: boxHeight, width: "150%"  }}/>
                </Form.Item>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="notificationEmail"
                  rules={[{ required: true, message: 'Please enter the notification email' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                >
                  <Input 
                  placeholder="Notifications Email"
                  type="email" 
                  style={{ height: boxHeight, width: "150%"  }}/>
                </Form.Item>
            </div>

                  {/* <Form.Item
                    label="Logo"
                    name="logo"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    extra="Upload your company logo"
                    style={{ fontSize: '16px' }}
                  >
                    <Upload name="logo" listType="picture">
                      <Button icon={<UploadOutlined />} style={{ height: boxHeight }}>Click to upload</Button>
                    </Upload>
                  </Form.Item> */}
              {/* Account Information */}
              <Title level={4} style={{marginTop: "10px"}}>Account Information</Title>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: 'Please enter the username' }]}
                  style={{ fontSize: '16px' , flex: '1', marginRight: "1%"}}
                >
                  <Input 
                  placeholder="Username"
                  style={{ height: boxHeight, width: "150%"}}/>
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[{ required: true, message: 'Please enter the password' }]}
                  style={{ fontSize: '16px', flex: '1' }}
                >
                  <Input.Password 
                  placeholder="Password"
                  style={{ height: boxHeight, width: "150%" }}/>
                </Form.Item>

              </div>
                {/* <Col span={12}>
                  <Form.Item
                    name="password"
                    rules={[{ required: true, message: 'Please enter the password' }]}
                    style={{ fontSize: '16px' }}
                  >
                    <Input.Password 
                    placeholder="Password"
                    style={{ height: boxHeight }}/>
                  </Form.Item>
                </Col> */}

              {/* Submit Button */}
              <div style={{ flexWrap: 'wrap', position: 'fixed', right: 30}}>
                <Form.Item>
                <Button 
                type="primary" htmlType="submit" 
                style={{ height: boxHeight, background: "#00308F" }}>
                    ADD
                </Button>
                </Form.Item>
              </div>
            </Form>

            <Modal
              title="Comapny Profile Created"
              visible={isChangeOk}
              onOk={handleModalOk}
              okText="OK"
              closable={false}
              cancelButtonProps={{ style: { display: 'none' } }}
              centered
            >
              {/* Additional content in the modal */}
            </Modal>

            <Modal
              title="Error Creating Company"
              visible={isChangeNotOk}
              onOk={handleModalNotOk}
              okText="OK"
              closable={false}
              cancelButtonProps={{ style: { display: 'none' } }}
              centered
            >
              {/* Additional content in the modal */}
            </Modal>

          </div>
      </Layout>
    </Layout>
  );
};

export default CustomerForm;



